// Un paragraphe par entrée : le bloc de présentation les rend tels quels.
export const whoWeAreParagraphs = [
  `Lacana est une boutique de CBD située à Etampes, nous proposons divers types de produits au cannabidiol répondant tous à la législation française et européenne.`,
  `Notre but est de proposer des produits de grande qualité et accessible à tous pour un mode de vie plus sain et sans stress.`,
  `Chaque produit est rigoureusement sélectionné en étroite collaboration avec nos partenaires cultivateurs situés en Europe.`
];
